import { Form, FormListItem } from '@entities/leadCollector';
import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';

interface FormListProps {
  forms?: Form[];
  chosenForm: Form | null;
  setChosenForm: (form: Form) => void;
  isLoading?: boolean;
  onPreviewTemplate: (formId: number) => void;
  setPrevStep: (step: number) => void;
  selectedForm?: Form | null;
}

const getSkeletons = () =>
  new Array(12).fill(0).map((_, index) => <div key={index} {...stylex.props(styles.skeleton)} />);

export const FormList = ({
  forms,
  chosenForm,
  setChosenForm,
  isLoading,
  onPreviewTemplate,
  setPrevStep,
  selectedForm,
}: FormListProps) => (
  <div {...stylex.props(styles.forms)}>
    {isLoading
      ? getSkeletons()
      : forms?.map((form) => (
          <FormListItem
            key={form.id}
            form={form}
            chosenForm={chosenForm}
            chooseForm={setChosenForm}
            onPreviewTemplate={onPreviewTemplate}
            setPrevStep={setPrevStep}
            selectedForm={selectedForm}
          />
        ))}
  </div>
);
